<template>
	<div class="container-fluid MainContainer">
		<section class="container">
			<div class="row align-items-center">
				<div class="py-5 col-9">
					<div>
						<img
							class="TabViewGradesAusbilder__titleImage TabViewGradesAusbilder__titleImage--specialLength"
							:src="textGrad5"
						/>
					</div>
					<div class="mt-4">
						{{
							$t(
								'navigationAusbildungsgrade.ausbildergrade.grad5.description.absatz1'
							)
						}}
						{{
							$t(
								'navigationAusbildungsgrade.ausbildergrade.grad5.description.absatz2'
							)
						}}
					</div>
					<div>
						{{
							$t(
								'navigationAusbildungsgrade.ausbildergrade.grad5.description.absatz3'
							)
						}}
					</div>
					<div class="mt-4">
						<h5 class="mb-2">Anforderungen</h5>

						<ul>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad5.requirements.requirement1'
									)
								}}
							</li>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad5.requirements.requirement2'
									)
								}}
							</li>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad5.requirements.requirement3'
									)
								}}
							</li>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad5.requirements.requirement4'
									)
								}}
							</li>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad5.requirements.requirement5'
									)
								}}
							</li>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad5.requirements.requirement6'
									)
								}}
							</li>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad5.requirements.requirement7'
									)
								}}
							</li>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad5.requirements.requirement8'
									)
								}}
							</li>
						</ul>
						<div>
							{{
								$t(
									'navigationAusbildungsgrade.ausbildergrade.grad5.conditions.condition1'
								)
							}}
						</div>
						<div>
							{{
								$t(
									'navigationAusbildungsgrade.ausbildergrade.grad5.conditions.condition2'
								)
							}}
						</div>
						<div>
							{{
								$t(
									'navigationAusbildungsgrade.ausbildergrade.grad5.conditions.condition3'
								)
							}}
						</div>
					</div>
				</div>

				<div class="py-5 col-9">
					<div>
						<img class="TabViewGradesAusbilder__titleImage" :src="textGrad6" />
					</div>
					<div class="mt-4">
						{{
							$t(
								'navigationAusbildungsgrade.ausbildergrade.grad6.description.absatz1'
							)
						}}
					</div>
					<div class="mt-4">
						<h5 class="mb-2">Anforderungen</h5>
						<ul>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad6.requirements.requirement1'
									)
								}}
							</li>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad6.requirements.requirement2'
									)
								}}
							</li>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad6.requirements.requirement3'
									)
								}}
							</li>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad6.requirements.requirement4'
									)
								}}
							</li>
						</ul>
					</div>
				</div>

				<div class="py-5 col-9">
					<div>
						<img
							class="TabViewGradesAusbilder__titleImage TabViewGradesAusbilder__titleImage--specialLength"
							:src="textGrad7"
						/>
					</div>
					<div class="mt-4">
						{{
							$t(
								'navigationAusbildungsgrade.ausbildergrade.grad7.description.absatz1'
							)
						}}
					</div>
					<div class="mt-4">
						<h5 class="mb-2">Anforderungen</h5>
						<ul>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad7.requirements.requirement1'
									)
								}}
							</li>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad7.requirements.requirement2'
									)
								}}
							</li>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad7.requirements.requirement3'
									)
								}}
							</li>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad7.requirements.requirement4'
									)
								}}
							</li>
						</ul>
					</div>
				</div>

				<div class="py-5 col-9">
					<div>
						<img class="TabViewGradesAusbilder__titleImage" :src="textGrad8" />
					</div>
					<div class="mt-4">
						{{
							$t(
								'navigationAusbildungsgrade.ausbildergrade.grad8.description.absatz1'
							)
						}}
						{{
							$t(
								'navigationAusbildungsgrade.ausbildergrade.grad8.description.absatz2'
							)
						}}
					</div>
					<div class="mt-4">
						<h5 class="mb-2">Anforderungen</h5>
						<ul>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad8.requirements.requirement1'
									)
								}}
							</li>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad8.requirements.requirement2'
									)
								}}
							</li>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad8.requirements.requirement3'
									)
								}}
							</li>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad8.requirements.requirement4'
									)
								}}
							</li>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad8.requirements.requirement5'
									)
								}}
							</li>
							<li>
								{{
									$t(
										'navigationAusbildungsgrade.ausbildergrade.grad8.requirements.requirement6'
									)
								}}
							</li>
						</ul>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import textWrestling from '@/assets/moduleTableText/textWrestling.png'
import textPrefight from '@/assets/moduleTableText/textPrefight.png'
import textInfight from '@/assets/moduleTableText/textInfight.png'
import textGrappling from '@/assets/moduleTableText/textGrappling.png'
import textWeapons from '@/assets/moduleTableText/textWeapons.png'
import textPostfight from '@/assets/moduleTableText/textPostfight.png'
import textGrad5 from '@/assets/moduleTableText/textGrad5.png'
import textGrad6 from '@/assets/moduleTableText/textGrad6.png'
import textGrad7 from '@/assets/moduleTableText/textGrad7.png'
import textGrad8 from '@/assets/moduleTableText/textGrad8.png'
import systemMixin from '@/views/system/systemMixin.js'

export default {
	name: 'TabViewGradesAusbilder',
	data() {
		return {
			textPostfight,
			textWeapons,
			textGrappling,
			textInfight,
			textPrefight,
			textWrestling,
			textGrad8,
			textGrad7,
			textGrad6,
			textGrad5
		}
	},
	mixins: [systemMixin]
}
</script>

<style scoped lang="styl">
.TabViewGradesAusbilder__titleImage {
	width: 75%;
}
</style>
